import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../InputField';
import FormError from '../FormError';
import { formatSaveStatus } from 'helpers/formatters';
import { prettyKey } from 'helpers/formatters';
import { required, maxLength255, maxLength20 } from 'helpers/validators';

let LeaseForm = (props) => {
  const {
    handleSubmit,
    error,
    saveStatus,
    subId,
    initialValues: {
      att_subscription,
      tracfone_subscription,
      simo_subscription,
    },
  } = props;
  let subscriptionLabel = 'Subscription';

  if (att_subscription) {
    subscriptionLabel = 'AT&T ' + subscriptionLabel;
  } else if (tracfone_subscription) {
    subscriptionLabel = 'Tracfone ' + subscriptionLabel;
  } else if (simo_subscription) {
    subscriptionLabel = 'Simo ' + subscriptionLabel;
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <strong>{subscriptionLabel}</strong> {subId}
        <br />
        <br />
        <Field
          component={InputField}
          name="description"
          label={prettyKey('description')}
          validate={[maxLength255]}
        />
        <Field
          component={InputField}
          name="linked_user_profile"
          label={prettyKey('linked_user_profile')}
          validate={[required]}
          parse={(value) => (value ? Number(value) : '')}
        />
        <Field
          component={InputField}
          name="imei"
          label={prettyKey('imei')}
          validate={[required, maxLength20]}
        />
        {/* <Field component={SelectField} name="lease_type" label={prettyKey("lease_type")}
              options={leaseTypeOptions} empty={true} /> */}
        {error && <FormError error={error} />}
        <br />
        <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
          Save Lease
        </button>
        <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
      </form>
    </div>
  );
};

LeaseForm = reduxForm({
  form: 'lease',
})(LeaseForm);

export default LeaseForm;
